export const MEXICAN_STATES = [
    {
        name: 'Aguascalientes',
        value: 'AGS',
    },
    {
        name: 'Baja California',
        value: 'BCN',
    },
    {
        name: 'Baja California SUR',
        value: 'BCS',
    },
    {
        name: 'Campeche',
        value: 'CAM',
    },
    {
        name: 'Chiapas',
        value: 'CHS',
    },
    {
        name: 'Chihuahua',
        value: 'CHI',
    },
    {
        name: 'Ciudad de México',
        value: 'CDMX',
    },
    {
        name: 'Coahuila de Zaragoza',
        value: 'COA',
    },
    {
        name: 'Colima',
        value: 'COL',
    },
    {
        name: 'Durango',
        value: 'DGO',
    },
    {
        name: 'Estado de México',
        value: 'EM',
    },
    {
        name: 'Guanajuato',
        value: 'GTO',
    },
    {
        name: 'Guerrero',
        value: 'GRO',
    },
    {
        name: 'Hidalgo',
        value: 'HGO',
    },
    {
        name: 'Jalisco',
        value: 'JAL',
    },
    {
        name: 'Michoacán de Ocampo',
        value: 'MICH',
    },
    {
        name: 'Morelos',
        value: 'MOR',
    },
    {
        name: 'Nayarit',
        value: 'NAY',
    },
    {
        name: 'Nuevo León',
        value: 'NL',
    },
    {
        name: 'Oaxaca',
        value: 'OAX',
    },
    {
        name: 'Puebla',
        value: 'PUE',
    },
    {
        name: 'Querétaro',
        value: 'QRO',
    },
    {
        name: 'Quintana Roo',
        value: 'QR',
    },
    {
        name: 'San Luis Potosí',
        value: 'SLP',
    },
    {
        name: 'Sinaloa',
        value: 'SIN',
    },
    {
        name: 'Sonora',
        value: 'SON',
    },
    {
        name: 'Tabasco',
        value: 'TAB',
    },
    {
        name: 'Tamaulipas',
        value: 'TAM',
    },
    {
        name: 'Tlaxcala',
        value: 'TLAX',
    },
    {
        name: 'Veracruz',
        value: 'VER',
    },
    {
        name: 'Yucatán',
        value: 'YUC',
    },
    {
        name: 'Zacatecas',
        value: 'ZAC',
    },
];
